module.exports = __webpack_public_path__ + "img/logo_lusitania-segurosjuntos.2bd9e4a6.png";